export enum ProductTypeEnum {
    eCPF = 1,
    eCNPJ = 2,
    ePF = 6,
    ePJ = 7
}
